import React from 'react';
import ValidationError from '../ValidationError';

interface Props {
  errorMessage: string;
  inputId: string;
  inputValue: string | number | readonly string[];
  isInvalid: boolean;
  maxLength: number;
  type: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onFocus?: () => void;
}

const TextInput = (props: Props) => {
  return (
    <>
      <input
        id={props.inputId}
        type={props.type}
        className={` w-100 p-2 ${props.isInvalid ? 'input-error' : 'text-input'}`}
        maxLength={props.maxLength}
        value={props.inputValue}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        onPaste={(e)=>{ if (props.type === "password" || props.inputId === "Password" || props.inputId === "ConfirmPassword")
          e.preventDefault()
          return false;
        }} 
      />
      <ValidationError
        isInvalid={props.isInvalid}
        message={props.errorMessage as string}
      />
    </>
  );
}

TextInput.defaultProps = {
  errorMessage: "Please enter a value for this field.",
  isInvalid: false,
  maxLength: 100,
  type: "text",
  onChange: undefined,
  onBlur: undefined,
  onFocus: undefined
}

export default TextInput;
